export const extractFileNameFromURL = (url: string) => {
  const path = new URL(url).pathname
  const urlParts = path.split('/')
  const fileName = urlParts[urlParts.length - 1]

  return decodeURIComponent(fileName)
}
